import axios from 'axios'
import { qs } from 'url-parse';

export default {
  fetchToken(context, {username, password}) {
    const url = `[keycloak]/realms/${process.env.VUE_APP_KEYCLOAK_REALM}/protocol/openid-connect/token`

    const body = qs.stringify({
      "grant_type": "password",
      "client_id": process.env.VUE_APP_KEYCLOAK_CLIENT,
      "username": username,
      "password": password,
    })

    const promise = axios.post(
      url, 
      body,
      { headers: { "content-type": "application/x-www-form-urlencoded" } },
    )

    promise.then(response => {
      context.commit('SET_TOKEN', response.data.access_token)
      context.commit('SET_REFRESH_TOKEN', response.data.refresh_token)
    }).catch((err) => {
      console.log(err)
      context.dispatch('showSnackbar', {text: 'Sign in failed', type: 'error'})
    })

    return promise
  },
  refreshToken(context) {
    const url = `[keycloak]/realms/${process.env.VUE_APP_KEYCLOAK_REALM}/protocol/openid-connect/token`

    const body = qs.stringify({
      "grant_type": "refresh_token",
      "client_id": process.env.VUE_APP_KEYCLOAK_CLIENT,
      "refresh_token": context.state.auth.refreshToken,
    })

    const promise = axios.post(
      url, 
      body,
      { headers: { "content-type": "application/x-www-form-urlencoded" } },
    )

    return promise.then(response => {
      context.commit('SET_TOKEN', response.data.access_token)
    }, () => {
      context.dispatch('logout')
    })
  },
  fetchUser(context) {
    const promise = axios.get(`[voyager]/user?appInstanceId=${process.env.VUE_APP_KEYCLOAK_CLIENT}`)

    return promise.then(response => {
      context.commit('SET_USER', response.data)
    }, () => {
      context.dispatch('logout')
      context.dispatch('showSnackbar', {text: 'Couldn\'t fetch user', type: 'error'})
    })
  },
  setUser(context, user) {
    context.commit('SET_USER', user)
  },
  logoutUser(context) {
    const url = `[keycloak]/realms/${process.env.VUE_APP_KEYCLOAK_REALM}/protocol/openid-connect/logout`

    const body = qs.stringify({
      "client_id": process.env.VUE_APP_KEYCLOAK_CLIENT,
      "refresh_token": context.state.auth.refreshToken,
    })

    axios.post(
      url, 
      body,
      { headers: { "content-type": "application/x-www-form-urlencoded" } },
    );

    console.log('logging out')
    context.commit('SET_TOKEN', null)
    context.commit('SET_REFRESH_TOKEN', null)
    context.commit('SET_USER', null)
  },
  breakToken(context) {
    context.commit('SET_TOKEN', '2iphbuei2bue2e')
    console.log('token broken')
    // context.dispatch('showSnackbar', {text: 'Broke the token. Ouch!', type: 'warning'})
  },
  breakRefreshToken(context) {
    context.commit('SET_REFRESH_TOKEN', '2iphbuei2bue2e')
    console.log('refresh token broken')
    // context.dispatch('showSnackbar', {text: 'Broke the refresh token. Owiee!', type: 'warning'})
  },
}
